<template>
	<span
		v-if="title"
		class="text-sm font-normal leading-[150%] text-primary-light-3"
	>
		{{ title }}
	</span>
	<div class="flex items-center gap-1">
		<span v-if="hasStart && rangeStart" :class="valueClasses">
			{{ rangeStart }}
		</span>
		<IconMaterialSymbolsLightArrowRange
			v-if="rangeEnd && rangeStart && hasStart"
			:class="cn('size-3 text-primary', iconClass)"
		/>
		<span :class="valueClasses">
			{{ rangeEnd }}
		</span>
	</div>
</template>

<script lang="ts" setup>
import type { VariantProps } from 'class-variance-authority';

import { cn } from '@/utils';

import { rangeLabelVariants } from '.';

const props = withDefaults(
	defineProps<{
		title?: string;
		rangeStart: string;
		rangeEnd: string;
		variant?: 'default' | 'light';
		size?: VariantProps<typeof rangeLabelVariants>['size'];
		iconClass?: string;
		valueClass?: string;
		hasStart?: boolean;
	}>(),
	{
		hasStart: true
	}
);

const valueClasses = computed(() =>
	cn(
		rangeLabelVariants({ variant: props.variant, size: props.size }),
		props.valueClass
	)
);
</script>
